<template>
    <ul class="filtro_ul filtro_checkbox">
        <li v-for="i in filter.items">
            <input :id="`${filter.key}-${i.key}`" type="checkbox"
                   :name="filter.key"
                   :value="i"
                   v-model="values">
            <label :for="`${filter.key}-${i.key}`">
                {{i.value}}
            </label>
        </li>
    </ul>
</template>

<script>


    export default {
        props: ['filter', 'filters'],
        data() {
            return {
                values: [],
            }
        },
        watch: {
            values: function () {
                this.$emit("change", this.filter, this.values && this.values.length > 0 ? this.values : null);
            },
            filters: function () {
                if (!this.filters || this.filters.length <= 0) {
                    this.values = [];
                }
            }
        },
        methods: {},
        mounted: function () {}
    }
</script>



// WEBPACK FOOTER //
// src/components/common/FilterCheckbox.vue